import React from 'react';
import { array, bool, node, object, string } from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { ListingCard, SearchListingCard, ListListingCard, PaginationLinks, Button } from '../../../components';

import css from './SearchResultsPanel.module.css';
import StoreCard from '../../../components/ListingCard/StoreCard';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    pagination,
    search,
    setActiveListing,
    isMapVariant,
    isSearch = true,
    stores,
    intl,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  const cardRenderSizes = isMapVariant => {
    if (isMapVariant) {
      // Panel width relative to the viewport
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 767px) 100vw',
        `(max-width: 1023px) ${panelMediumWidth}vw`,
        `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
        `${panelLargeWidth / 3}vw`,
      ].join(', ');
    } else {
      // Panel width relative to the viewport
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 549px) 100vw',
        '(max-width: 767px) 50vw',
        `(max-width: 1439px) 26vw`,
        `(max-width: 1920px) 18vw`,
        `14vw`,
      ].join(', ');
    }
  };

  const ListingContainer = isSearch ? SearchListingCard : ListListingCard;

  const availableStores = stores && Array.isArray(stores) && stores.length;

  return (
    <>
    <div className={classes}>
      <div className={isSearch ? (isMapVariant ? css.listingCardsMapVariant : css.listingCards) : css.noSearchListingCards}>
        {listings.map(l => (
          <ListingContainer
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes(isMapVariant)}
            setActiveListing={setActiveListing}
            stores={stores}
            creators={props.creators}
          />
        ))}
        {props.children}
      </div>
      <Button type="button" className={css.toggleMap} onClick={() => props.toggleMap()}>{intl.formatMessage({ id: 'SearchPage.toggleMap' })}</Button>
      {paginationLinks}
      {availableStores ? (
        <>
          <h2 className={css.storesHeading}>Bowtackle Certified Sellers</h2>
          <div className={css.storesContainer}>
            {stores
              .sort((a, b) => (b.listings?.length || 0) - (a.listings?.length || 0))
              .map(store => <StoreCard store={store} key={store?.id?.uuid}/>)}
          </div>
        </>
      ) : null}
    </div>
    </>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  stores: [],
  pagination: null,
  rootClassName: null,
  search: null,
  isMapVariant: true,
};

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  stores: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
  isMapVariant: bool,
};

export default SearchResultsPanel;
